import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// location-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  updateSelectedReserveList(store, payload) {
    store.commit('updateSelectedReserveList', payload)
  },
  clearSelectedReserveList(store) {
    store.commit('clearSelectedReserveList')
  },
  async addReserve(store, payload) {
    const count = 900 * 1024
    const fileData = payload.file
    const totalSize = fileData.length
    let logContinue = true
    let pageNo = 0
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            name: payload.name,
            time: payload.time,
            fileName: payload.fileName,
            file: fileData.slice(pageNo * count, pageNo * count + count),
            startFlag: pageNo === 0,
            endFlag: false
          }
        ]
      }

      pageNo++
      if (totalSize <= pageNo * count) {
        data.data[0].endFlag = true
        logContinue = false
      }

      await Vue.http.post(URL + '/v2/admin/reserve/regist', data, config)
    }
  },
  async setReserves(store, payload) {
    store.state.reserves = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          pageNo: payload.pageNo,
          count: 20
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/reserve/list',
      data,
      config
    )
    // 成功
    store.commit('setReserves', response)
  },
  async updateReserve(store, payload) {
    const count = 900 * 1024
    const fileData = payload.file
    if (!fileData) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [{ ...payload, startFlag: true, endFlag: true }]
      }
      await Vue.http.post(URL + '/v2/admin/reserve/update', data, config)
      return
    }

    const totalSize = fileData.length
    let logContinue = true
    let pageNo = 0
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            reserveId: payload.reserveId,
            name: payload.name,
            time: payload.time,
            fileName: payload.fileName,
            file: fileData.slice(pageNo * count, pageNo * count + count),
            startFlag: pageNo === 0,
            endFlag: false
          }
        ]
      }

      pageNo++
      if (totalSize <= pageNo * count) {
        data.data[0].endFlag = true
        logContinue = false
      }

      await Vue.http.post(URL + '/v2/admin/reserve/update', data, config)
    }
  },
  async deleteReserve(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          reserveId: payload.reserveId
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/reserve/delete', data, config)
  },
  async setDetailReserve(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          reserveId: payload.reserveId
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/reserve/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  },
  async verifyReserve(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          reserveId: payload.reserveId
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/reserve/verify', data, config)
  },
  async setDownloadFile(store, payload) {
    let logContinue = true
    let count = 0
    const fileChunks = []
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 30
      }
      const data = {
        header,
        data: [
          {
            reserveId: payload.reserveId,
            count: count
          }
        ]
      }
      var response = await Vue.http.post(
        URL + '/v2/admin/reserve/download',
        data,
        config
      )

      fileChunks.push(response.data.data[0]['file'])
      count += response.data.data[0]['file'].length
      if (!response.data.data[0]['remain']) {
        logContinue = false
      }
    }

    const binary = atob(fileChunks.join(''))
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i)
    }

    store.commit('downloadFile', {
      headers: {
        'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      data: bytes
    })
  },
  async downloadTemplate(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      responseType: 'arraybuffer',
      timeout: 1000 * 30
    }
    var response = await Vue.http.get(
      URL + '/v2/admin/reserve/template',
      config
    )
    store.commit('downloadTemplate', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reserveModules/actions.js